import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Button, Row, Select, Spin } from "antd";
import { toastError } from "../../../helpers/toasters";
import { login, updateFBToken } from "../../../store/authorization";
import { ROUTES } from "../../../constants/_routes";
import { signInApi } from "../../../network";
import LanguageBtn from "../../Common/LanguageBtn/LanguageBtn";
import GlobalModal from "../GlobalModal";
import logoIcon from "../../../assets/images/logo.png";
// import flag from "../../../assets/icons/egypt-flag.svg";
import egFlag from "../../../assets/icons/egypt-flag.svg";
import aeFlag from "../../../assets/icons/emirates-flag.svg";

function SignIn() {
  const [selectedCountry, setSelectedCountry] = useState("eg");
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mobile, setMobile] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [sendCodeTo, setSendCodeTo] = useState("mobile");
  const { fbToken } = useSelector((state) => state.auth);
  const { authorization } = useSelector((state) => state?.auth);
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const [rememebrMe, setRememberMe] = useState(true);
  const { dir } = useSelector((state) => state.language);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (authorization.token) {
      if (authorization?.isEmirate) {
        navigate("/buy-and-supply/buy", { replace: true });
      } else {
        navigate("/home", { replace: true });
      }
    } else {
      setIsAuthenticated(false);
    }
  }, [authorization]);

  useEffect(() => {
    const fbToken = localStorage.getItem("fbToken");
    dispatch(updateFBToken({ fbToken }));
  }, []);

  // Phone handler
  const handleOnChangePhone = (e) => {
    if (selectedCountry === "eg") {
      const phoneRegex = /^[\d]*$/;
      if (phoneRegex.test(e.target.value)) {
        setMobile(e.target.value);
        setPhoneError("");
      } else {
        return;
      }
      if (e.target.value.length === 0) {
        setPhoneError("requiredMobile");
      } else {
        let phoneLen = 11;
        let charLen = 2;
        if (!e.target.value.startsWith("0")) {
          phoneLen = 10;
          charLen = 1;
        }
        if (
          e.target.value.length > phoneLen ||
          (e.target.value.length >= charLen &&
            !e.target.value.startsWith(`${charLen === 2 ? "0" : ""}1`)) ||
          (e.target.value.length >= charLen + 1 &&
            !e.target.value.startsWith(`${charLen === 2 ? "0" : ""}10`) &&
            !e.target.value.startsWith(`${charLen === 2 ? "0" : ""}11`) &&
            !e.target.value.startsWith(`${charLen === 2 ? "0" : ""}12`) &&
            !e.target.value.startsWith(`${charLen === 2 ? "0" : ""}15`)) ||
          e.target.value.length < 10 ||
          (e.target.value.length === 10 && e.target.value.startsWith("0"))
        ) {
          setPhoneError("invalidMobile");
        }
      }
    } else if (selectedCountry === "ae") {
      const phoneRegex = /^[\d]*$/;
      if (phoneRegex.test(e.target.value)) {
        setMobile(e.target.value);
        setPhoneError("");
      } else {
        return;
      }

      if (e.target.value.length === 0) {
        setPhoneError("requiredMobile");
      } else {
        const validPrefixes = ["50", "52", "53", "54", "55", "56", "57", "58"];
        const prefix = e.target.value.substring(0, 2);

        if (
          e.target.value.length > 9 ||
          (e.target.value.length >= 2 && !validPrefixes.includes(prefix))
        ) {
          setPhoneError("invalidMobile");
        }
      }
    }
  };

  const onCancel = () => {
    setIsModalOpen(false);
  };

  const handleRememberMe = () => {
    setRememberMe(!rememebrMe);
  };

  const handleSignIn = (method) => {
    setSendCodeTo(method);
    // Validate phone number
    if (!mobile) {
      setPhoneError("requiredMobile");
      return;
    } else if (
      selectedCountry === "eg" &&
      (mobile.length > 11 || mobile.length < 10)
    ) {
      setPhoneError("invalidMobile");
      return;
    } else if (mobile.length === 10 && mobile.startsWith("0")) {
      setPhoneError("invalidMobile");
      return;
    } else if (selectedCountry === "ae" && mobile.length !== 9) {
      setPhoneError("invalidMobile");
      return;
    }

    if (phoneError) return;

    setLoading(true);
    const data = {
      mobile:
        selectedCountry === "eg"
          ? `2${
              mobile.length === 10 && !mobile.startsWith("0") ? "0" : ""
            }${mobile}`
          : `971${mobile}`,
      fireBaseToken: fbToken?.fbToken,
    };

    signInApi(
      data,
      (success) => {
        if (success?.success) {
          setLoading(false);
          setIsModalOpen(true);
          const authObj = { ...success.data, keepSignedIn: rememebrMe };
          dispatch(login(authObj));
        } else {
          setLoading(false);
          toastError(success.message);
        }
      },
      (fail) => {
        setLoading(false);
        toastError(fail?.data?.error);
      },
      method,
    );
  };

  const onFinish = (e) => {
    e.preventDefault();
    handleSignIn("mobile");
  };

  const handleEmailSignIn = () => {
    handleSignIn("email");
  };

  return !isAuthenticated ? (
    <section className="mct-section mct-section-signin d-flex justify-content-center align-items-center">
      <div className="auth-nav w-100 fixed-top d-flex align-items-center justify-content-between py-3 px-4">
        <div className="logo">
          <img className="icon" src={logoIcon} alt="logo" />
        </div>
        <LanguageBtn inNavbar={false} />
      </div>
      <div className="contact-us__content">
        <Row justify={"center"} className="wd-100">
          <form onSubmit={onFinish} className="contact-us__form wd-100">
            <h1 className="text-center fsize-8 green-text w-100 mb-4">
              {t("auth.login")}
            </h1>

            <div dir={dir} className="contact-us__form-field my-3">
              <label className="fsize-9">{t("auth.phone")}</label>
              <div
                className={`${
                  dir === "rtl" ? "ps-0" : "pe-0"
                } py-0 d-flex align-items-center gap-1 contact-us__form-input ${
                  phoneError ? "border border-1 border-danger" : "border-0"
                }`}
              >
                <Select
                  className="form-phone"
                  value={selectedCountry}
                  onChange={(v) => {
                    setSelectedCountry(v);
                    setPhoneError(null);
                    setMobile("");
                  }}
                  options={[
                    {
                      label: (
                        <div className="d-flex align-items-center gap-2">
                          <img src={egFlag} alt="egypt flag" width="20" />
                          <span>+20</span>
                        </div>
                      ),
                      value: "eg",
                    },
                    {
                      label: (
                        <div className="d-flex align-items-center gap-2">
                          <img src={aeFlag} alt="emirates flag" width="20" />
                          <span>+971</span>
                        </div>
                      ),
                      value: "ae",
                    },
                  ]}
                />

                <div className="flex-fill">
                  <input
                    type="text"
                    name="phone"
                    value={mobile}
                    onChange={handleOnChangePhone}
                    className="contact-us__form-input ps-2 outline-0 fsize-8 border-0"
                  />
                </div>
              </div>

              {phoneError && (
                <span className="contact-us__field-error fsize-10 mt-1">
                  {t(`auth.${phoneError}`)}
                </span>
              )}
            </div>

            <div
              dir={dir}
              className={`w-100 d-flex align-items-center gap-2 my-2`}
            >
              <input
                type="checkbox"
                name="terms-and-conditions"
                id="rememberMe"
                className="auth-checkbox"
                checked={rememebrMe}
                onChange={handleRememberMe}
              />
              <label htmlFor="rememberMe" className="fsize-10">
                {t("auth.rememberMe")}
              </label>
            </div>

            <div className="sign-in-btns mt-2 mt-md-4 d-flex gap-3 flex-column justify-content-between align-items-center w-100">
              <Button
                loading={loading}
                className="sign-in-btn border-0 fsize-9 h-auto"
                htmlType="submit"
              >
                {t("auth.login")}
              </Button>
              <div className="sign-up-btn fsize-9">
                <span className="white-text">{t("auth.noAccount")} </span>
                <Link
                  to={ROUTES.SIGNUP}
                  className="fw-semibold green-text h-auto"
                >
                  {t("auth.signup")}
                </Link>
              </div>
              <div
                className="fw-semibold green-text h-auto text-decoration-underline fsize-9"
                onClick={handleEmailSignIn}
                style={{ cursor: "pointer" }}
              >
                {t("auth.signInWithEmail")}
              </div>
            </div>
          </form>
        </Row>
      </div>
      {isModalOpen && (
        <GlobalModal
          name="otp-modal"
          isModalOpen={isModalOpen}
          onCancel={onCancel}
          keepSignedIn={rememebrMe}
          data={{
            selectedCountry,
            sendCodeTo,
            mobile:
              selectedCountry === "eg"
                ? `2${mobile.length === 10 ? "0" : ""}${mobile}`
                : `971${mobile}`,
            fireBaseToken: "fireBaseToken",
            deviceId: "deviceId",
          }}
        />
      )}
    </section>
  ) : (
    <div>
      <Spin
        size="large"
        className="spin-overlay w-100 h-100 position-absolute top-0 start-0 d-flex justify-content-center align-items-center"
      ></Spin>
    </div>
  );
}

export default SignIn;

// function SignIn() {
//   const [selectedCountry, setSelectedCountry] = useState("eg");
//   const [loading, setLoading] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [mobile, setMobile] = useState("");
//   const [phoneError, setPhoneError] = useState("");
//   const { fbToken } = useSelector((state) => state.auth);
//   const { authorization } = useSelector((state) => state?.auth);
//   const [isAuthenticated, setIsAuthenticated] = useState(true);
//   const [rememebrMe, setRememberMe] = useState(true);

//   const [sendCodeTo, setSendCodeTo] = useState("mobile");

//   const { dir } = useSelector((state) => state.language);
//   const { t } = useTranslation();
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   // useEffect(() => {
//   //   if (authorization.token) {
//   //     navigate("/home", { replace: true });
//   //   } else {
//   //     setIsAuthenticated(false);
//   //   }
//   // }, []);

//   useEffect(() => {
//     if (authorization.token) {
//       if (authorization?.isEmirate) {
//         navigate("/buy-and-supply/buy", { replace: true });
//       } else {
//         navigate("/home", { replace: true });
//       }
//     } else {
//       setIsAuthenticated(false);
//     }
//   }, [authorization]);

//   useEffect(() => {
//     const fbToken = localStorage.getItem("fbToken");
//     dispatch(updateFBToken({ fbToken }));
//   }, []);

//   // const handleOnChangePhone = (e) => {
//   //   const phoneRegex = /^[\d]*$/;
//   //   if (phoneRegex.test(e.target.value)) {
//   //     setMobile(e.target.value);
//   //     setPhoneError("");
//   //   } else {
//   //     return;
//   //   }
//   //   if (e.target.value.length === 0) {
//   //     setPhoneError("requiredMobile");
//   //   } else {
//   //     let phoneLen = 11;
//   //     let charLen = 2;
//   //     if (!e.target.value.startsWith("0")) {
//   //       phoneLen = 10;
//   //       charLen = 1;
//   //     }
//   //     if (
//   //       e.target.value.length > phoneLen ||
//   //       (e.target.value.length >= charLen &&
//   //         !e.target.value.startsWith(`${charLen === 2 ? "0" : ""}1`)) ||
//   //       (e.target.value.length >= charLen + 1 &&
//   //         !e.target.value.startsWith(`${charLen === 2 ? "0" : ""}10`) &&
//   //         !e.target.value.startsWith(`${charLen === 2 ? "0" : ""}11`) &&
//   //         !e.target.value.startsWith(`${charLen === 2 ? "0" : ""}12`) &&
//   //         !e.target.value.startsWith(`${charLen === 2 ? "0" : ""}15`))
//   //     ) {
//   //       setPhoneError("invalidMobile");
//   //     }
//   //   }
//   // };

//   // phone handler
//   const handleOnChangePhone = (e) => {
//     if (selectedCountry === "eg") {
//       const phoneRegex = /^[\d]*$/;
//       if (phoneRegex.test(e.target.value)) {
//         setMobile(e.target.value);
//         setPhoneError("");
//       } else {
//         return;
//       }
//       if (e.target.value.length === 0) {
//         setPhoneError("requiredMobile");
//       } else {
//         let phoneLen = 11;
//         let charLen = 2;
//         if (!e.target.value.startsWith("0")) {
//           phoneLen = 10;
//           charLen = 1;
//         }
//         if (
//           e.target.value.length > phoneLen ||
//           (e.target.value.length >= charLen &&
//             !e.target.value.startsWith(`${charLen === 2 ? "0" : ""}1`)) ||
//           (e.target.value.length >= charLen + 1 &&
//             !e.target.value.startsWith(`${charLen === 2 ? "0" : ""}10`) &&
//             !e.target.value.startsWith(`${charLen === 2 ? "0" : ""}11`) &&
//             !e.target.value.startsWith(`${charLen === 2 ? "0" : ""}12`) &&
//             !e.target.value.startsWith(`${charLen === 2 ? "0" : ""}15`))
//         ) {
//           setPhoneError("invalidMobile");
//         }
//       }
//     } else if (selectedCountry === "ae") {
//       const phoneRegex = /^[\d]*$/;
//       if (phoneRegex.test(e.target.value)) {
//         setMobile(e.target.value);
//         setPhoneError("");
//       } else {
//         return;
//       }

//       if (e.target.value.length === 0) {
//         setPhoneError("requiredMobile");
//       } else {
//         const validPrefixes = ["50", "52", "53", "54", "55", "56", "57", "58"];
//         const prefix = e.target.value.substring(0, 2);

//         if (
//           e.target.value.length > 9 ||
//           (e.target.value.length >= 2 && !validPrefixes.includes(prefix))
//         ) {
//           setPhoneError("invalidMobile");
//         }
//       }
//     }
//   };

//   const onCancel = () => {
//     setIsModalOpen(false);
//   };

//   const handleRememberMe = () => {
//     setRememberMe(!rememebrMe);
//   };

//   const onFinish = (e) => {
//     e.preventDefault();
//     // if (!mobile) {
//     //   setPhoneError("requiredMobile");
//     // } else if (mobile.length > 11 || mobile.length < 10) {
//     //   setPhoneError("invalidMobile");
//     // }

//     if (!mobile) {
//       setPhoneError("requiredMobile");
//       setSendCodeTo("mobile");
//     } else if (
//       selectedCountry === "eg" &&
//       (mobile.length > 11 || mobile.length < 10)
//     ) {
//       setPhoneError("invalidMobile");
//       setSendCodeTo("mobile");
//     } else if (selectedCountry === "ae" && mobile.length !== 9) {
//       setPhoneError("invalidMobile");
//       setSendCodeTo("mobile");
//     }

//     if (
//       // mobile &&
//       // (mobile.length === 11 || mobile.length === 10) &&
//       ((selectedCountry === "eg" &&
//         (mobile.length === 10 || mobile.length === 11)) ||
//         (selectedCountry === "ae" && mobile.length === 9)) &&
//       !phoneError
//     ) {
//       setLoading(true);
//       const data = {
//         // mobile: `2${mobile.length === 10 ? "0" : ""}${mobile}`,
//         mobile:
//           selectedCountry === "eg"
//             ? `2${mobile.length === 10 ? "0" : ""}${mobile}`
//             : `971${mobile}`,
//         fireBaseToken: fbToken?.fbToken,
//       };
//       signInApi(
//         data,
//         (success) => {
//           if (success?.success) {
//             setLoading(false);
//             setIsModalOpen(true);
//             const authObj = { ...success.data, keepSignedIn: rememebrMe };
//             dispatch(login(authObj));
//           } else {
//             setLoading(false);
//             toastError(success.message);
//           }
//         },
//         (fail) => {
//           setLoading(false);
//           toastError(fail?.data?.error);
//         },
//         sendCodeTo
//       );
//     }
//   };

//   useEffect(() => {
//     if (setSendCodeTo === "email") {
//       onFinish();
//     }
//   }, [setSendCodeTo]);

//   return !isAuthenticated ? (
//     <section className="mct-section mct-section-signin d-flex justify-content-center align-items-center">
//       <div className="auth-nav w-100 fixed-top d-flex align-items-center justify-content-between py-3 px-4">
//         <div className="logo">
//           <img className="icon" src={logoIcon} alt="logo" />
//         </div>
//         <LanguageBtn inNavbar={false} />
//       </div>
//       <div className="contact-us__content">
//         <Row justify={"center"} className="wd-100">
//           <form onSubmit={onFinish} className="contact-us__form wd-100">
//             <h1 className="text-center fsize-8 green-text w-100 mb-4">
//               {t("auth.login")}
//             </h1>
//             {/* <div dir={dir} className="contact-us__form-field mb-4">
//               <label className="fsize-9">{t("auth.phone")}</label>
//               <div
//                 className={`${
//                   dir === "rtl" ? "ps-0" : "pe-0"
//                 } py-0 d-flex align-items-center gap-1 gap-sm-2 contact-us__form-input ${
//                   phoneError ? "border border-1 border-danger" : "border-0"
//                 }`}
//               >
//                 <div className="d-flex align-items-center gap-1">
//                   <div>
//                     <img src={flag} alt="" className="d-block img-fluid" />
//                   </div>
//                   <div className="contact-us__country-code flex-fill">
//                     <span className="d-block fsize-9">+20</span>
//                   </div>
//                 </div>
//                 <div className="flex-fill">
//                   <input
//                     type={"text"}
//                     name="phone"
//                     value={mobile}
//                     onChange={handleOnChangePhone}
//                     className={`contact-us__form-input ps-2 outline-0 fsize-8 border-0`}
//                   />
//                 </div>
//               </div>
//               {phoneError && (
//                 <span className="contact-us__field-error fsize-10 mt-1">
//                   {t(`auth.${phoneError}`)}
//                 </span>
//               )}
//             </div> */}

//             <div dir={dir} className="contact-us__form-field my-3">
//               <label className="fsize-9">{t("auth.phone")}</label>
//               <div
//                 className={`${
//                   dir === "rtl" ? "ps-0" : "pe-0"
//                 } py-0 d-flex align-items-center gap-1 contact-us__form-input ${
//                   phoneError ? "border border-1 border-danger" : "border-0"
//                 }`}
//               >
//                 <Select
//                   className="form-phone"
//                   value={selectedCountry}
//                   onChange={(v) => {
//                     setSelectedCountry(v);
//                     setPhoneError(null);
//                     setMobile("");

//                     // if (v === "ae") {
//                     //   setIdNumber("");
//                     //   setIdNumberError("");
//                     // }
//                   }}
//                   options={[
//                     {
//                       label: (
//                         <div className="d-flex align-items-center gap-2">
//                           <img src={egFlag} alt="egypt flag" width="20" />
//                           <span>+20</span>
//                         </div>
//                       ),
//                       value: "eg",
//                     },
//                     {
//                       label: (
//                         <div className="d-flex align-items-center gap-2">
//                           <img src={aeFlag} alt="egypt flag" width="20" />
//                           <span>+971</span>
//                         </div>
//                       ),
//                       value: "ae",
//                     },
//                   ]}
//                 />

//                 <div className="flex-fill">
//                   <input
//                     type="text"
//                     name="phone"
//                     value={mobile}
//                     onChange={handleOnChangePhone}
//                     className="contact-us__form-input ps-2 outline-0 fsize-8 border-0"
//                     // placeholder={
//                     //   selectedCountry === "eg"
//                     //     ? "Eg: 10xxxxxxxx"
//                     //     : "UAE: 50xxxxxxx"
//                     // }
//                   />
//                 </div>
//               </div>

//               {phoneError && (
//                 <span className="contact-us__field-error fsize-10 mt-1">
//                   {t(`auth.${phoneError}`)}
//                 </span>
//               )}
//             </div>
//             <div
//               dir={dir}
//               className={`w-100 d-flex align-items-center gap-2 my-2`}
//             >
//               <input
//                 type="checkbox"
//                 name="terms-and-conditions"
//                 id="rememberMe"
//                 className="auth-checkbox"
//                 checked={rememebrMe}
//                 onChange={handleRememberMe}
//               />
//               <label htmlFor="rememberMe" className="fsize-10">
//                 {t("auth.rememberMe")}
//               </label>
//             </div>
//             <div className="sign-in-btns mt-2 mt-md-4 d-flex gap-3 flex-column justify-content-between align-items-center w-100">
//               <Button
//                 loading={loading}
//                 className="sign-in-btn border-0 fsize-9 h-auto"
//                 htmlType="submit"
//               >
//                 {t("auth.login")}
//               </Button>
//               <div className="sign-up-btn fsize-9">
//                 <span className="white-text">{t("auth.noAccount")} </span>
//                 <Link
//                   to={ROUTES.SIGNUP}
//                   className="fw-semibold green-text h-auto"
//                 >
//                   {t("auth.signup")}
//                 </Link>
//               </div>
//               <div
//                 className="fw-semibold green-text h-auto text-underline"
//                 onClick={() => setSendCodeTo("email")}
//                 style={{ cursor: "pointer" }}
//               >
//                 {t("auth.signInWithEmail")}
//               </div>
//             </div>
//           </form>
//         </Row>
//       </div>
//       {isModalOpen && (
//         <GlobalModal
//           name="otp-modal"
//           isModalOpen={isModalOpen}
//           onCancel={onCancel}
//           keepSignedIn={rememebrMe}
//           data={{
//             // mobile: `2${mobile.length === 10 ? "0" : ""}${mobile}`,
//             selectedCountry,
//             mobile:
//               selectedCountry === "eg"
//                 ? `2${mobile.length === 10 ? "0" : ""}${mobile}`
//                 : `971${mobile}`,
//             fireBaseToken: "fireBaseToken",
//             deviceId: "deviceId",
//           }}
//         />
//       )}
//     </section>
//   ) : (
//     <div>
//       <Spin
//         size="large"
//         className="spin-overlay w-100 h-100 position-absolute top-0 start-0 d-flex justify-content-center align-items-center"
//       ></Spin>
//     </div>
//   );
// }
